module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.24463",
      "conversations-internal-schema": "static-1.11964",
      "head-dlb": "static-1.4360",
      "hs-test-utils": "static-1.7320",
      "hubspot-url-utils": "static-1.3545",
      "HubStyleTokens": "static-2.10831",
      "I18n": "static-7.1450",
      "jasmine-runner": "static-1.5740",
      "quartz": "static-1.6125",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.475",
      "visitor-ui-component-library": "static-1.5487",
      "enviro": "static-4.328",
      "hs-promise-rejection-tracking": "static-1.4750",
      "PortalIdParser": "static-2.306",
      "raven": "static-3.5229",
      "raven-hubspot": "static-1.5536",
      "bend-plugin-trellis-migration": "static-1.2865",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1327",
      "hub-http": "static-1.5499",
      "immutable": "static-2.19",
      "immutable-less": "static-1.3876",
      "quartz-core": "static-1.5344",
      "transmute": "static-2.75",
      "HeadJS": "static-2.622",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.6815",
      "framer-motion": "static-1.52",
      "hs-test-utils-bend-plugin": "static-1.2431",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.134",
      "foundations-theming": "static-1.3659",
      "i18n-data": "static-1.207",
      "metrics-js": "static-1.9076",
      "moment-timezone": "static-5.67",
      "react-utils": "static-2.4720",
      "jasmine": "static-4.3638",
      "quartz-core-utils": "static-1.2992",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.44",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7778",
      "visitor-ui-component-library-icons": "static-1.5298",
      "rpc-client-utils": "static-1.4024",
      "ts-schema": "static-1.3508",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.121",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.696",
      "hub-http-shared-msw-handlers": "static-1.8345",
      "hubspotter-http": "static-1.3981",
      "hubspotter-http-shared-msw-handlers": "static-1.8343",
      "icons": "static-2.593",
      "mobile-manifest-mixins": "static-1.393",
      "platform-navigation-bootstrap": "static-1.11809",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1.15910",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.333",
      "bend-plugin-foundations-components": "static-1.3084",
      "floating-ui": "static-1.40",
      "foundations-assets": "static-1.4186",
      "foundations-theming-specialty": "static-1.1375",
      "hs-story-utils": "static-1.8683",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.81",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.961",
      "bend-plugin-foundations-theming": "static-1.2142",
      "foundations-theming-base": "static-1.2644",
      "classnames": "static-2.10",
      "cssUtils": "static-1.596",
      "HubStyle": "static-2.11139",
      "sassPrefix": "static-1.140",
      "platform-infra-nav-components": "static-1.7091",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.24463",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11964",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-test-utils": "/hs-test-utils/static-1.7320",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3545",
      "HubStyleTokens": "/HubStyleTokens/static-2.10831",
      "I18n": "/I18n/static-7.1450",
      "jasmine-runner": "/jasmine-runner/static-1.5740",
      "quartz": "/quartz/static-1.6125",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.475",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5487",
      "enviro": "/enviro/static-4.328",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "raven": "/raven/static-3.5229",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2865",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1327",
      "hub-http": "/hub-http/static-1.5499",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.3876",
      "quartz-core": "/quartz-core/static-1.5344",
      "transmute": "/transmute/static-2.75",
      "HeadJS": "/HeadJS/static-2.622",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.6815",
      "framer-motion": "/framer-motion/static-1.52",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2431",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.134",
      "foundations-theming": "/foundations-theming/static-1.3659",
      "i18n-data": "/i18n-data/static-1.207",
      "metrics-js": "/metrics-js/static-1.9076",
      "moment-timezone": "/moment-timezone/static-5.67",
      "react-utils": "/react-utils/static-2.4720",
      "jasmine": "/jasmine/static-4.3638",
      "quartz-core-utils": "/quartz-core-utils/static-1.2992",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.44",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7778",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5298",
      "rpc-client-utils": "/rpc-client-utils/static-1.4024",
      "ts-schema": "/ts-schema/static-1.3508",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.121",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.696",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8345",
      "hubspotter-http": "/hubspotter-http/static-1.3981",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8343",
      "icons": "/icons/static-2.593",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.393",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11809",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1.15910",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.333",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3084",
      "floating-ui": "/floating-ui/static-1.40",
      "foundations-assets": "/foundations-assets/static-1.4186",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1375",
      "hs-story-utils": "/hs-story-utils/static-1.8683",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.81",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.961",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2142",
      "foundations-theming-base": "/foundations-theming-base/static-1.2644",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.596",
      "HubStyle": "/HubStyle/static-2.11139",
      "sassPrefix": "/sassPrefix/static-1.140",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7091",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};